import { getData, putData } from "../apiClient";

// get roles for permission management
export const getRolesForPermission = async () => {
    try {
        const result = await getData("/role/permission/getrole");
        return {
            data: {
                message: result.message,
                success: true,
                data: result
            }
        };
    } catch (error) {
        console.error('Get roles for permission API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};

// get menus for permission management
export const getMenusForPermission = async () => {
    try {
        const result = await getData("/menu/get");
        return {
            data: {
                message: result.message,
                success: true,
                data: result
            }
        };
    } catch (error) {
        console.error('Get menus for permission API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};

// get role permissions by role id
export const getRolePermissions = async ({ id }) => {
    try {
        const result = await getData(`/role/permission/getOne/${id}`);
        return {
            data: {
                message: result.message,
                success: true,
                data: result
            }
        };
    } catch (error) {
        console.error('Get role permissions API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};

// update role permissions
export const updateRolePermissions = async ({ data }) => {
    try {
        const result = await putData("/role/permission/update", data);
        return {
            data: {
                message: result.message,
                success: true,
                data: result
            }
        };
    } catch (error) {
        console.error('Update role permissions API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};
